export default __webpack_public_path__ + "static/media/Astro_Uranus_Black.11ffbaae.png";